<!-- height here is to avoid the page flicker which is created during the change in position of the header -->
<div [ngStyle]="{ height: desktopHeaderHeight$ | async }">
  <div [ngClass]="headerClasses$ | async">
    <header data-testing-id="page-header" class="top" id="header">
      <ng-container [ngSwitch]="headerType$ | async">
        <ish-header-error *ngSwitchCase="'error'"></ish-header-error>
        <ish-header-simple *ngSwitchCase="'simple'"></ish-header-simple>
        <ish-header-checkout *ngSwitchCase="'checkout'"></ish-header-checkout>

        <ng-container *ngSwitchDefault>
          <custom-header-default
            [isSticky]="isSticky$ | async"
            [deviceType]="deviceType$ | async"
            [reset]="reset$ | async"
          ></custom-header-default>
        </ng-container>
      </ng-container>
    </header>
  </div>
</div>
